import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';

import { Box } from '../../Box';
import { Text } from '../../Text';
import { InputProps } from './InputProps';

const { textInput: textInputTokens } = tokens;

/**
 * Error message for input components
 */
export const InputError = ({ errorText }: Pick<InputProps, 'errorText'>) =>
  !!errorText && typeof errorText === 'string' ? (
    <Box testID="text-input-error-message">
      <Text
        tag="span"
        typography={textInputTokens.typography.errorText.default}
        color={textInputTokens.color.content.errorMessage.default}
      >
        {errorText}
      </Text>
    </Box>
  ) : null;
